export default __webpack_public_path__ + "801bfd08b53f8ea5aa88045c2690f95b.png";